
      import Phone from './phone.vue'
      import type { App, Plugin } from 'vue'

      export const PhonePlugin: Plugin = {
        install(app: App) {
          app.component('Phone', Phone)
        },
      }
      export { Phone }
      